/**
 * rainbowSlider
 * Copyright (C) by Rainbow Themes
 * All rights reserved
 */

;(function($) {
	$.fn.rainbowSlider = function( options ){
		
		var data = $(this).attr('data-rainbow'),
			opts = {};

		if(typeof(data)!=='undefined') {
			data = data.split(',');

			opts = {
				transition: data[0],
				effect: data[1],
				animationTime: data[2],
				pauseTime: data[3]
			};
		}

		options = $.extend( {}, $.fn.rainbowSlider.defaults, opts, options );

		return this.each( function() {
			var timer = null;
			var hover = false;
			var container = $(this);
			var slides = $( '.mt-rainbow-slide', container );
			var n = slides.length;
			if( n<2 )
				$( '.mt-rainbow-slider-arrow-left, .mt-rainbow-slider-arrow-right', container ).hide();

			var sliderWidth = container.width();
			
			var current = 0;
			var duringAnimation = false;
			
			slides.each(function(i) {
				if(options.effect == 'fade')
					$(this).css({backgroundColor: options.backgrounds[i]});
				else if(options.effect != 'slide2')
					$(this).css({left: sliderWidth+'px'});
			});
			
			if(options.effect == 'slide2') {
				slides.each(function(i) {
					$(this).css({marginLeft: (-490+980*i) + 'px'});
				});

				if(slides.length>2) {
					var lastClone = slides.last().css({marginLeft: '-1470px'});
				}
			} else {
				slides.eq(0).css({left:0});
			}
			
			function changeSlide( direction ) {
				if(duringAnimation) return false;
				
				var newSlideElement,
					parentNode,
					tmp,
						
				
				
				duringAnimation = true;
				var newSlide = current + direction;
				if( newSlide >= n ) newSlide = 0;
				else if ( newSlide == -1 ) newSlide = n-1;

				
				switch(options.effect) {
					case 'fade-old':
						slides.eq(current).css({'z-index': 1});
						newSlideElement = slides.eq(newSlide).css({'z-index': 2, display:'block', opacity: 0} );
						parentNode = $('>div>div', newSlideElement);
							newSlideElement.animate( { opacity:1 }, {
								duration: options.animationTime,
								complete: function() {
									slides.eq(current).css({opacity:1, display: 'none'});
									current = newSlide;
									duringAnimation = false;
								}
							} );
						break;

					case 'fade':
						slides.eq(current).css({'z-index': 1});
						newSlideElement = slides.eq(newSlide).css({'z-index': 2, display:'block', opacity: 0} );

						parentNode = $('>div>div', newSlideElement);
						var isLeft = parentNode.hasClass('mt-rainbow-slide-left');

						$('>h1,>h2,>p,>div', parentNode).css({opacity:0, marginLeft: (isLeft ? '-' : '') +'500px'});
						$('>h2', parentNode).css({marginLeft: (isLeft ? '' : '-') +'500px'});

							newSlideElement.animate( { opacity:1 }, {duration: options.animationTime/2, complete: function() {

									// left

									$('h1', parentNode).animate({marginLeft:0, opacity:1},{duration: options.animationTime/6});
									$('h2', parentNode).doTimeout(150, function(){
										$(this).animate({marginLeft:0, opacity:1},{duration: options.animationTime/6});
									});
									$('p,div', parentNode).doTimeout(300, function(){
										$(this).animate({marginLeft:0, opacity:1},{duration: options.animationTime/6});
									});

									slides.eq(current).css({opacity:1, display: 'none'});
									current = newSlide;
									duringAnimation = false;
								}
							} );
						break;
					case 'slide':
						newSlideElement = slides.eq(newSlide).css({'z-index': 1, display:'block', left: (-direction*sliderWidth)+'px' } );

						parentNode = $('>div>div', newSlideElement);
						isLeft = parentNode.hasClass('mt-rainbow-slide-left');
						$('>h1,>h2,>p,>div', parentNode).css({opacity:0, marginLeft: (isLeft ? '-' : '') +'500px'});
						$('>h2', parentNode).css({marginLeft: (isLeft ? '' : '-') +'500px'});

						slides.eq(current).css({'z-index': 0}).animate( { left: direction*sliderWidth+'px' }, { queue:false, duration: options.animationTime } );
						newSlideElement.animate( { left:0 }, { queue:false, duration: options.animationTime, complete: function() {
								
									$('h1', parentNode).animate({marginLeft:0, opacity:1},{duration: options.animationTime/6});
									$('h2', parentNode).doTimeout(150, function(){
										$(this).animate({marginLeft:0, opacity:1},{duration: options.animationTime/6});
									});
									$('p,div', parentNode).doTimeout(300, function(){
										$(this).animate({marginLeft:0, opacity:1},{duration: options.animationTime/6});
									});
								
								
								current = newSlide;
								duringAnimation = false;
						} } );
						break;
					case 'slide2':
						
						newSlideElement = slides.eq(newSlide);
						if(direction==1) { // ->
							tmp = current+2;
							if(tmp>=n) tmp = tmp%n;

							slides.eq(tmp).css('marginLeft' , parseInt(slides.eq(current).css('marginLeft'))+980+980 + 'px');
							
						} else { // <-
							tmp = current-2;
							if(tmp<0) tmp += n;
							slides.eq(tmp).css('marginLeft' , parseInt(slides.eq(current).css('marginLeft'))-980-980 + 'px');
							
						}

						slides.animate({marginLeft: (direction==1 ? '-' : '+') +'=980px'}, function(){								
								
								current = newSlide;
								duringAnimation = false;
						});
						
						break;
					case 'slide-fade':
						newSlideElement = slides.eq(newSlide).css({'z-index': 1, display:'block', left: (-direction*sliderWidth)+'px', opacity: 0 } );

						parentNode = $('>div>div', newSlideElement);
						isLeft = parentNode.hasClass('mt-rainbow-slide-left');
						$('>h1,>h2,>p,>div', parentNode).css({opacity:0, marginLeft: (isLeft ? '-' : '') +'500px'});
						$('>h2', parentNode).css({marginLeft: (isLeft ? '' : '-') +'500px'});

						slides.eq(current).css({'z-index': 0}).animate( { left: direction*sliderWidth+'px', opacity: 0 }, { queue:false, duration: options.animationTime } );
						newSlideElement.animate( { left:0, opacity: 1 }, { queue:false, duration: options.animationTime, complete: function() {

									$('h1', parentNode).animate({marginLeft:0, opacity:1},{duration: options.animationTime/6});
									$('h2', parentNode).doTimeout(150, function(){
										$(this).animate({marginLeft:0, opacity:1},{duration: options.animationTime/6});
									});
									$('p,div', parentNode).doTimeout(300, function(){
										$(this).animate({marginLeft:0, opacity:1},{duration: options.animationTime/6});
									});
								
								current = newSlide;
								duringAnimation = false;
						} } );
						break;
					}
					
					if(!hover)
						timer = setTimeout(function(){changeSlide( 1 );}, options.pauseTime);
			}
			
			$(this).hover(function(){
				hover = true;
				clearTimeout(timer);
			}, function(){
				hover = false;
				clearTimeout(timer);
				timer = setTimeout(function(){changeSlide( 1 );}, options.pauseTime);
			});
			
			timer = setTimeout(function(){changeSlide( 1 );}, options.pauseTime);
			
			$( '.mt-rainbow-slider-arrow-right', container ).click( function() {
				clearTimeout(timer);
				hover = true;
				changeSlide(1);
			});

			$( '.mt-rainbow-slider-arrow-left', container ).click( function() {
				clearTimeout(timer);
				hover = true;
				changeSlide(-1);
			});
			
		});
	};

	$.fn.rainbowSlider.defaults = {
		animationTime: 1800,
		pauseTime: 8000,
		easing: 'easeOutSine',
		effect: 'slide', // 'fade',
		backgrounds: []
	};
})(jQuery);